/* ═══════════════════════════════════════════════════════════
   js/shared.js — Общая логика БРОНИДОМ v15
   Подключается на КАЖДОЙ странице через footer.php
   Содержит: scroll, nav, modals, FAQ, phone mask, animations
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  // Рейтинг района / walkability: единый display-floor (SSOT для JS, шкала /100; /10 = /10).
  // PHP-зеркало define('RATING_FLOOR', 60) в app/config.php; синхронность — RatingFloorSyncTest.
  window.RATING_FLOOR = 60;

  // BuildStatus (SSOT статуса сдачи) вынесен в отдельный js/build-status.js,
  // загружается из footer.php ДО страничных JS. См. BuildStatusJsSyncTest.

  // ── PWA: Service Worker регистрация ──
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/service-worker.js').catch(function() {});
  }

  // ── Preloader: НЕ показывать на мобиле (perf) ──
  // Владелец 2026-07-09: «прелоадер звёзд на телефоне уберём, чтоб не грузил сайт».
  // Убираем #preloader СРАЗУ (shared.js грузится defer ПЕРЕД index.js — footer.php),
  // поэтому canvas-анимация звёзд в index.js (getElementById('preloaderCanvas') →
  // if(!canvas)return) и fallback ниже (pre===null) молча выходят: rAF-цикл + 280 звёзд
  // на телефоне не стартуют вообще. Контент под оверлеем сразу виден (reveal fade-up
  // идёт через IntersectionObserver, не завязан на прелоадер). pointer:coarse — тот же
  // сигнал «телефон/тач», что и CSS-страховка @media(pointer:coarse) в css/main.css.
  var preloaderIsMobile = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  if (preloaderIsMobile) {
    var preMobile = document.getElementById('preloader');
    if (preMobile && preMobile.parentNode) {
      preMobile.parentNode.removeChild(preMobile);
    }
  }

  // ── Preloader fallback (для всех страниц кроме index) ──
  // index.js имеет свою анимацию прелоадера. На остальных — авто-скрытие.
  window.addEventListener('load', function() {
    const pre = document.getElementById('preloader');
    if (pre && !pre.classList.contains('hidden')) {
      const bar = document.getElementById('preloaderBarFill');
      const pct = document.getElementById('preloaderPercent');
      if (bar) bar.style.width = '100%';
      if (pct) pct.textContent = '100%';
      setTimeout(function() { pre.classList.add('hidden'); }, 400);
    }
  });

  // ── Яндекс.Метрика helper ──
  if (typeof window.ymGoal === 'undefined') {
    window.ymGoal = function(t, p) {
      try { if (typeof ym === 'function') ym(window.YM_COUNTER_ID, 'reachGoal', t, p || {}); } catch(e) {}
    };
  }

  // ── Атрибуция офлайн-конверсий Директа: персист yclid/utm в first-party куку ──
  // КОРЕНЬ (2026-07-20): раньше атрибуцию собирал ТОЛЬКО квиз podbor.js из URL СВОЕЙ
  // страницы формы → навигация/редирект/async-гонка теряли yclid (0 из 10 броней имели
  // хоть одно поле атрибуции). ФИКС: на ЛЮБОЙ странице, если в URL есть yclid/utm_*,
  // кладём их в куку bd_attr (JSON, 90 дней, SameSite=Lax, Path=/). Сервер
  // (BroniDom\Marketing\Attribution) читает её при создании брони из любой формы
  // (квиз/flat.php/AI-консультант). Last-touch: свежий клик по рекламе перезаписывает поле.
  (function persistAttribution() {
    try {
      var params = new URLSearchParams(window.location.search);
      var keys = ['yclid', 'utm_source', 'utm_medium', 'utm_campaign'];
      var incoming = {};
      var hasNew = false;
      keys.forEach(function(k) {
        var v = (params.get(k) || '').trim();
        // Тот же whitelist, что на сервере (\A[\w.\-]+\z) — мусор в куку не тащим.
        if (v && /^[\w.-]+$/.test(v)) { incoming[k] = v.slice(0, 120); hasNew = true; }
      });
      if (!hasNew) return;
      var current = {};
      var m = document.cookie.match(/(?:^|;\s*)bd_attr=([^;]+)/);
      if (m) {
        try { current = JSON.parse(decodeURIComponent(m[1])) || {}; } catch (e) { current = {}; }
      }
      keys.forEach(function(k) { if (incoming[k]) current[k] = incoming[k]; });
      var maxAge = 90 * 24 * 60 * 60;
      var secure = window.location.protocol === 'https:' ? '; Secure' : '';
      document.cookie = 'bd_attr=' + encodeURIComponent(JSON.stringify(current)) +
        '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax' + secure;
    } catch (e) { /* атрибуция — best-effort, страницу не ломаем */ }
  })();

  // ── SCROLL PROGRESS BAR ──
  const bar = document.getElementById('scrollProgress');
  if (bar) {
    window.addEventListener('scroll', () => {
      const d = document.documentElement;
      bar.style.width = Math.min(d.scrollTop / (d.scrollHeight - d.clientHeight) * 100, 100) + '%';
    }, { passive: true });
  }

  // ── CURRENT YEAR ──
  const yearEl = document.getElementById('currentYear');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // ── HEADER: scrolled-state + hide-on-scroll (вниз прячем, вверх показываем;
  // у верха ≤240px и при открытом меню — всегда видна) ──
  const hdr = document.getElementById('mainHeader');
  if (hdr) {
    const navEl = document.getElementById('mainNav');
    let lastY = window.pageYOffset, ticking = false;
    const onHdr = () => {
      const y = window.pageYOffset;
      hdr.classList.toggle('scrolled', y > 60);
      if ((navEl && navEl.classList.contains('active')) || y <= 240 || y < lastY - 5) hdr.classList.remove('header-hidden');
      else if (y > lastY + 5) hdr.classList.add('header-hidden');
      // Sticky фильтр-бар каталога (.nv-filterbar) уезжает вместе с шапкой.
      document.body.classList.toggle('hdr-hidden', hdr.classList.contains('header-hidden'));
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onHdr); ticking = true; } }, { passive: true });
  }

  // ── MOBILE MENU ──
  const mbList = [document.getElementById('mobileMenuBtn'), document.getElementById('mobileMenuBtnTop')].filter(Boolean);
  const nav = document.getElementById('mainNav');
  const syncBtns = (open) => {
    mbList.forEach(b => {
      b.setAttribute('aria-expanded', String(open));
      const i = b.querySelector('i');
      if (i) {
        i.classList.toggle('fa-bars', !open);
        i.classList.toggle('fa-times', open);
      }
    });
  };
  if (mbList.length && nav) {
    mbList.forEach(mb => {
      mb.addEventListener('click', () => {
        const isOpen = nav.classList.toggle('active');
        syncBtns(isOpen);
        if (window.toggleMobileMenu) window.toggleMobileMenu();
      });
    });
    nav.querySelectorAll('.nav-link').forEach(l => {
      l.addEventListener('click', () => {
        nav.classList.remove('active');
        syncBtns(false);
      });
    });
    // ⛔ Здесь стояло число 768 — двойник брейкпоинта вёрстки: 26.08.2026 полоса бургера
    //    расширилась до 1024, и число молча разошлось бы со стилями (при повороте телефона
    //    иконка вернулась бы к «бургеру» поверх открытого ящика). Спрашиваем у самой кнопки,
    //    видна ли она, — брейкпоинт живёт только в CSS. Плюс закрываем ящик: открытым на
    //    настольной ширине он держал бы `body{overflow:hidden}`, а кнопки закрыть его нет.
    window.addEventListener('resize', () => {
      if (mbList.some(b => b.offsetParent !== null)) return;
      nav.classList.remove('active');
      syncBtns(false);
      if (window.closeMobileMenu) window.closeMobileMenu();
    });
  }

  // ── ACTIVE NAV LINK ──
  const path = location.pathname.split('/').pop() || 'index.php';
  document.querySelectorAll('#mainNav .nav-link, .md-link, .nav-link').forEach(a => {
    const h = a.getAttribute('href');
    if (h === path || location.pathname.endsWith(h)) a.classList.add('active');
  });

  // ── SMOOTH SCROLL ANCHORS ──
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function(e) {
      const h = this.getAttribute('href');
      if (h.length <= 1) return;
      const t = document.querySelector(h);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // ── SCROLL TO TOP ──
  const stb = document.getElementById('scrollToTop') || document.querySelector('.scroll-to-top');
  if (stb) {
    window.addEventListener('scroll', () => {
      stb.classList.toggle('show', window.pageYOffset > 400);
    }, { passive: true });
    stb.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ── PARALLAX BACKGROUND ──
  const abg = document.getElementById('animBg');
  if (abg) {
    let tick = false;
    window.addEventListener('scroll', () => {
      if (!tick) {
        requestAnimationFrame(() => {
          abg.style.transform = 'translateY(' + window.pageYOffset * 0.4 + 'px)';
          tick = false;
        });
        tick = true;
      }
    }, { passive: true });
  }

  // ── PHONE MASK (+7 format) ──
  /* ⛔ ПО ПРИЗНАКУ, А НЕ ПО СПИСКУ (24.08.2026). Было `querySelectorAll('.phone-input')`
     один раз на загрузке — два молчаливых изъяна: класс надо не забыть проставить
     (у 14 полей телефона из 23 его не было НИКОГДА), а разовый проход не видит форм,
     которые скрипт рисует позже (ещё 10 полей, включая быструю заявку карточки
     квартиры). Делегат на документе цепляет поле сам: событие `input` всплывает.
     Дешевле MutationObserver и переживает любую перерисовку.
     ⛔ ОПТ-АУТ, А НЕ ОПТ-ИН: не всякий `type="tel"` — номер, этим типом зовут цифровую
     клавиатуру. Помечены `data-no-phone-mask` клетки SMS-кода в кабинете (maxlength=1,
     маска сломала бы вход) и поиск по клиентам у риелтора (ищут и по имени с почтой).
     Полный разбор: .planning/NAHODKA-MASKA-TELEFONA-PO-PRIZNAKU-2026-08-24.md */
  const PHONE_MASK_SEL = 'input[type="tel"]:not([data-no-phone-mask]),'
    + 'input.phone-input:not([data-no-phone-mask])';

  // Разбор номера НЕ менялся: тот же код, что работал с .phone-input, вынесен в функцию.
  function formatRuPhone(raw) {
    let d = String(raw == null ? '' : raw).replace(/\D/g, '');
    if (d.startsWith('8')) d = '7' + d.slice(1);
    if (!d.startsWith('7')) d = '7' + d;
    d = d.slice(0, 11);
    let o = '+7';
    if (d.length > 1) o += ' (' + d.slice(1, 4);
    if (d.length >= 5) o += ') ' + d.slice(4, 7);
    if (d.length >= 8) o += '-' + d.slice(7, 9);
    if (d.length >= 10) o += '-' + d.slice(9, 11);
    return o;
  }

  // Вставка из буфера своего слушателя не требует: браузер шлёт `input` и после paste,
  // и после автоподстановки — все пути приходят сюда.
  document.addEventListener('input', (e) => {
    const inp = e.target;
    if (!inp || inp.nodeType !== 1 || inp.tagName !== 'INPUT') return;
    if (typeof inp.matches !== 'function' || !inp.matches(PHONE_MASK_SEL)) return;
    inp.value = formatRuPhone(inp.value);
  });

  // ── FADE-UP / INTERSECTION OBSERVER ──
  // Auto-add fade-up to common elements
  document.querySelectorAll(
    '.card,.service-card,.advantage-item,.team-member,.review-card,.blog-card,' +
    '.portfolio-card,.process-step,.timeline-step,.city-card,.req-card,.bank-card,.aside-card,' +
    '.grid-2>*,.grid-3>*,.grid-4>*,.services-grid>*,.advantages-grid>*,' +
    '.team-grid>*,.reviews-grid>*,.process-grid>*,.banks-grid>*,.req-grid>*,.districts-grid>*'
  ).forEach(el => {
    if (!el.classList.contains('fade-up')) el.classList.add('fade-up');
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      // Stat number counter animation
      if (el.classList.contains('stat-number') && !el.classList.contains('animated')) {
        el.classList.add('animated');
        const p = el.closest('.stat');
        if (p) p.classList.add('in-view');
        const tgt = parseInt(el.getAttribute('data-target'), 10);
        if (!tgt) return;
        const dur = 2000, st = performance.now();
        function step(now) {
          const pr = Math.min((now - st) / dur, 1);
          const ea = 1 - Math.pow(1 - pr, 4);
          el.textContent = Math.floor(ea * tgt).toLocaleString('ru-RU');
          if (pr < 1) requestAnimationFrame(step);
          else { el.textContent = tgt.toLocaleString('ru-RU'); el.classList.add('counted'); }
        }
        requestAnimationFrame(step);
      }
      // Fade-up animation
      if (el.classList.contains('fade-up') || el.classList.contains('fade-in') || el.classList.contains('slide-up')) {
        el.classList.add('in-view');
        el.classList.add('visible');
        io.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

  document.querySelectorAll('.stat-number,.fade-up,.fade-in,.slide-up').forEach(el => io.observe(el));

  // ── MODALS (open/close) ──
  function openModal(id) {
    const m = document.getElementById(id);
    if (m) {
      m.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeModal(id) {
    const m = document.getElementById(id);
    if (m) {
      m.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  // Expose globally for onclick handlers
  window.openModal = openModal;
  window.closeModal = closeModal;
  window.openCallbackModal = () => openModal('callbackModal');

  // LEGAL 2026-07-06: перехват .privacy-link/.consent-link/*-trigger → модалки УДАЛЁН.
  // Устаревшие #privacyModal/#consentModal убраны из футера; ссылки ведут на
  // актуальные страницы /policy.php и /soglasie.php обычной навигацией.
  // Close buttons [data-close]
  document.querySelectorAll('[data-close]').forEach(btn => {
    btn.addEventListener('click', () => closeModal(btn.getAttribute('data-close')));
  });
  // Close on overlay click
  document.querySelectorAll('.modal').forEach(modal => {
    if (modal) modal.addEventListener('click', e => { if (e.target === modal) closeModal(modal.id); });
  });
  // Close on Escape
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.modal.active').forEach(m => closeModal(m.id));
    }
  });

  // ── CALLBACK FORM (site-wide) ──
  // Блок 1.1: модалка глобальная (footer.php), но AJAX-submit жил только в index.js —
  // на остальных страницах нативный POST уводил юзера на голый JSON send.php.
  function sharedToast(text, borderColor, textColor, role) {
    const t = document.createElement('div');
    t.setAttribute('role', role || 'status');
    if (role !== 'alert') t.setAttribute('aria-live', 'polite');
    t.style.cssText = 'position:fixed;bottom:24px;right:24px;z-index:99999;background:#1c1c22;border:1px solid ' + borderColor + ';color:' + textColor + ';padding:14px 20px;border-radius:12px;font-size:13px;font-weight:700;box-shadow:0 8px 30px rgba(0,0,0,0.5)';
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 5000);
    return t;
  }
  const cbForm = document.getElementById('callbackForm');
  if (cbForm) cbForm.addEventListener('submit', async e => {
    e.preventDefault();
    const cbPhone = document.getElementById('cbPhone');
    const cbAgree = document.getElementById('cbAgreement');
    const cbBtn = cbForm.querySelector('button[type="submit"]');
    if (cbBtn && cbBtn.disabled) return; // двойной клик = дубль заявки
    const digits = cbPhone ? cbPhone.value.replace(/\D/g, '') : '';
    if (digits.length !== 11) { if (cbPhone) { cbPhone.style.borderColor = '#f87171'; cbPhone.focus(); setTimeout(() => { cbPhone.style.borderColor = ''; }, 2500); } return; }
    if (cbAgree && !cbAgree.checked) { const lbl = cbAgree.closest('label') || cbAgree.parentElement; if (lbl) { lbl.style.color = '#f87171'; setTimeout(() => { lbl.style.color = ''; }, 2500); } return; }
    const fd = new FormData(e.target);
    if (!fd.has('_hp')) fd.append('_hp', '');
    fd.set('_source', 'Заказать звонок'); if (cbForm.hasAttribute('data-lead-source')) fd.set('_source', cbForm.getAttribute('data-lead-source')); // метка страницы — js/jk-rooms-lead.js
    cbForm.setAttribute('aria-busy', 'true');
    if (cbBtn) cbBtn.disabled = true;
    try {
      const res = await fetch('/send.php', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (res.ok) {
        sharedToast('✅ Заявка принята! Перезвоним в ближайшее время.', 'rgba(74,222,128,0.4)', '#4ade80', 'status');
        if (typeof ymGoal === 'function') ymGoal('form_callback');
        closeModal('callbackModal');
        e.target.reset();
      } else if (res.status === 429) {
        sharedToast('⚠️ Слишком много запросов. Попробуйте через минуту.', 'rgba(250,204,21,0.4)', '#facc15', 'alert');
      } else throw new Error();
    } catch {
      const t = sharedToast('⚠️ Ошибка отправки. Позвоните нам: ', 'rgba(248,113,113,0.4)', '#f87171', 'alert');
      const link = document.createElement('a');
      link.href = 'tel:+79191701918';
      link.style.color = '#f87171';
      link.textContent = '8 (919) 170-19-18';
      t.appendChild(link);
    } finally {
      cbForm.removeAttribute('aria-busy');
      if (cbBtn) cbBtn.disabled = false;
    }
  });

  // ── UNIVERSAL CONSENT GATE (lead-delivery hotfix, 2026-07-16) ──
  // 152-ФЗ ст. 9 ч. 4: без отметки consent_main заявку НЕ отправляем. НО кнопку submit
  // БОЛЬШЕ НЕ дизейблим. Раньше (jk-redesign 4.1) гейт ставил btn.disabled=true до галочки —
  // клиент заполнял имя/телефон, жал «мёртвую» кнопку, ничего не происходило (ни отправки,
  // ни подсказки) и уходил уверенный что отправил → тихая потеря лида (реальный кейс из
  // Директа 2026-07-16). Новый паттерн: перехват submit на CAPTURE-фазе — без галочки
  // preventDefault + stopImmediatePropagation (чтобы формные обработчики не сработали) +
  // видимая подсказка .consent-hint + фокус на чекбокс. С галочкой — обработчики формы
  // работают штатно. Формы со своим гейтом (data-consent-gate-skip на форме/кнопке)
  // пропускаются — они сами показывают ту же .consent-hint через window.showConsentHint.

  // Подсказка под чекбоксом согласия. Создаётся один раз на форму, далее show/hide.
  function consentHintFor(cb, create) {
    if (!cb) return null;
    var label = null;
    if (cb.id) {
      var sel = (window.CSS && window.CSS.escape) ? window.CSS.escape(cb.id) : cb.id;
      label = document.querySelector('label[for="' + sel + '"]');
    }
    if (!label) label = cb.closest('label');
    var anchor = label || cb;
    var parent = anchor.parentElement || cb.parentElement;
    if (!parent) return null;
    var hint = parent.querySelector('.consent-hint');
    if (!hint && create) {
      hint = document.createElement('div');
      hint.className = 'consent-hint';
      hint.setAttribute('role', 'alert');
      hint.setAttribute('aria-live', 'polite');
      hint.hidden = true;
      hint.textContent = 'Отметьте согласие на обработку персональных данных';
      if (anchor.nextSibling) parent.insertBefore(hint, anchor.nextSibling);
      else parent.appendChild(hint);
    }
    return hint || null;
  }
  function showConsentHint(cb) {
    var hint = consentHintFor(cb, true);
    if (!hint) return;
    hint.hidden = false;
    hint.classList.remove('consent-hint--attn');
    void hint.offsetWidth; // reflow → повторный запуск мягкой анимации внимания
    hint.classList.add('consent-hint--attn');
    try { cb.focus(); } catch (e) { /* focus может кинуть в редких кейсах — не блокируем */ }
  }
  function hideConsentHint(cb) {
    var hint = consentHintFor(cb, false);
    if (hint) { hint.hidden = true; hint.classList.remove('consent-hint--attn'); }
  }
  // Экспорт для страничных JS с собственным гейтом (podbor.js / flat.js) — единая подсказка.
  window.showConsentHint = showConsentHint;
  window.hideConsentHint = hideConsentHint;

  (function initConsentGate() {
    document.querySelectorAll('input[name="consent_main"]').forEach(function (cb) {
      var form = cb.closest('form');
      if (!form) return;
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      // Форма со своим гейтом пропускается (семантика data-consent-gate-skip сохранена).
      if (form.hasAttribute('data-consent-gate-skip')) return;
      if (btn && btn.hasAttribute('data-consent-gate-skip')) return;
      // Кнопку НЕ дизейблим. Перехват на capture-фазе — раньше обработчиков формы.
      form.addEventListener('submit', function (e) {
        if (cb.checked) { hideConsentHint(cb); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        showConsentHint(cb);
      }, true);
      cb.addEventListener('change', function () { if (cb.checked) hideConsentHint(cb); });
    });
  })();

  // ── FAQ ACCORDION ──
  document.querySelectorAll('.faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      if (!item) return;
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq-item.open').forEach(el => {
        el.classList.remove('open');
        const q = el.querySelector('.faq-question');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      // Open clicked (if it was closed)
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ── CURSOR GLOW (desktop only) ──
  const isMob = window.matchMedia('(max-width:768px)').matches;
  const prm = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if (!prm && !isMob) {
    const glow = document.createElement('div');
    glow.className = 'cursor-glow';
    document.body.appendChild(glow);
    let gx = 0, gy = 0, cx = 0, cy = 0;
    document.addEventListener('mousemove', e => { gx = e.clientX; gy = e.clientY; glow.classList.add('active'); });
    document.addEventListener('mouseleave', () => { glow.classList.remove('active'); });
    (function gl() { cx += (gx - cx) * 0.08; cy += (gy - cy) * 0.08; glow.style.left = cx + 'px'; glow.style.top = cy + 'px'; requestAnimationFrame(gl); })();
  }

  // ── CARD TILT HOVER (desktop only) ──
  if (!prm && !isMob) {
    document.querySelectorAll('.service-card,.advantage-item,.team-member,.review-card,.card,.blog-card,.req-card,.bank-card,.aside-card').forEach(c => {
      c.addEventListener('mousemove', e => {
        const r = c.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'translateY(-8px) perspective(800px) rotateY(' + x * 6 + 'deg) rotateX(' + -y * 6 + 'deg)';
      });
      c.addEventListener('mouseleave', () => {
        c.style.transform = '';
        c.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
        setTimeout(() => { c.style.transition = ''; }, 500);
      });
    });
  }

  // ── RIPPLE EFFECT ──
  document.querySelectorAll('button,.cta-button,.btn-gold,.btn,.submit-button,.calculator-button').forEach(b => {
    b.addEventListener('click', function(e) {
      if (this.disabled) return;
      const r = document.createElement('span');
      r.classList.add('ripple');
      // Ripple ставит relative ТОЛЬКО static-кнопкам: fixed/absolute/sticky
      // (плавающая FAB Алисы #aiFab и т.п.) перетирать нельзя — выбьет из вьюпорта.
      let _pos = '';
      try { _pos = getComputedStyle(this).position; } catch (_e) { _pos = ''; }
      if (_pos === '' || _pos === 'static') this.style.position = 'relative';
      this.style.overflow = 'hidden';
      this.appendChild(r);
      const rect = this.getBoundingClientRect();
      const sz = Math.max(rect.width, rect.height);
      r.style.cssText = 'width:' + sz + 'px;height:' + sz + 'px;left:' + (e.clientX - rect.left - sz / 2) + 'px;top:' + (e.clientY - rect.top - sz / 2) + 'px;';
      // overflow:hidden ОБЯЗАН сниматься после анимации: для flex-элемента он
      // обнуляет автоматический min-size → чип на мобиле схлопывается в иконку
      // (баг владельца 23.07: «нажал "Сначала дорогие" — свернулась в иконку»).
      r.addEventListener('animationend', () => {
        r.remove();
        if (!this.querySelector('.ripple')) this.style.overflow = '';
      });
    });
  });

  // ── TEXT REVEAL OBSERVER ──
  if (!prm) {
    const to = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('revealed'); to.unobserve(e.target); }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -60px 0px' });
    document.querySelectorAll('.section-title,.section-tag,.hero-title,.hero-eyebrow').forEach(el => to.observe(el));
  }

  // ── STAGGER REVEAL FOR GRIDS ──
  document.querySelectorAll('.services-grid,.advantages-grid,.team-grid,.reviews-grid,.process-grid,.grid-2,.grid-3,.grid-4,.banks-grid,.req-grid,.districts-grid').forEach(g => {
    g.classList.add('stagger-reveal');
  });

  // ── HERO PARALLAX (desktop only) ──
  if (!prm && !isMob) {
    const hero = document.querySelector('.hero,.page-hero');
    if (hero) {
      window.addEventListener('scroll', () => {
        const s = window.scrollY;
        if (s > window.innerHeight) return;
        const b = hero.querySelector('.hero-badge,.hero-eyebrow');
        const t = hero.querySelector('.hero-title');
        const u = hero.querySelector('.hero-subtitle,.hero-desc');
        const st = hero.querySelector('.hero-stats');
        if (b) b.style.transform = 'translateY(' + s * 0.04 + 'px)';
        if (t) t.style.transform = 'translateY(' + s * 0.08 + 'px)';
        if (u) u.style.transform = 'translateY(' + s * 0.12 + 'px)';
        if (st) st.style.transform = 'translateY(' + s * 0.06 + 'px)';
      }, { passive: true });
    }
  }

  // ── CARD SPOTLIGHT (desktop only) ──
  if (!prm && !isMob) {
    document.querySelectorAll('.service-card,.advantage-item,.card,.blog-card,.req-card').forEach(c => {
      c.addEventListener('mousemove', e => {
        const r = c.getBoundingClientRect();
        c.style.background = 'radial-gradient(300px circle at ' + (e.clientX - r.left) + 'px ' + (e.clientY - r.top) + 'px,rgba(200,169,110,0.06),transparent 60%),var(--dark3)';
      });
      c.addEventListener('mouseleave', () => { c.style.background = ''; });
    });
  }

  // ── ICON HOVER GLOW ──
  if (!prm && !isMob) {
    document.querySelectorAll('.card-icon,.service-icon,.doc-icon').forEach(ic => {
      const p = ic.closest('.card,.service-card,.footer-doc-item');
      if (!p) return;
      p.addEventListener('mouseenter', () => {
        ic.style.background = 'rgba(200,169,110,0.2)';
        ic.style.borderColor = '#c8a96e';
        ic.style.color = '#e8c98e';
        ic.style.boxShadow = '0 0 20px rgba(200,169,110,0.15)';
      });
      p.addEventListener('mouseleave', () => {
        ic.style.background = ''; ic.style.borderColor = ''; ic.style.color = ''; ic.style.boxShadow = '';
      });
    });
  }

  // ── MAGNETIC BUTTONS (desktop only) ──
  if (!prm && !isMob) {
    document.querySelectorAll('.cta-button,.header-phone,.submit-button,.btn-gold,.btn').forEach(b => {
      b.addEventListener('mousemove', e => {
        const r = b.getBoundingClientRect();
        const x = e.clientX - r.left - r.width / 2;
        const y = e.clientY - r.top - r.height / 2;
        b.style.transform = 'translate(' + x * 0.15 + 'px,' + y * 0.15 + 'px)';
      });
      b.addEventListener('mouseleave', () => {
        b.style.transform = '';
        b.style.transition = 'transform 0.4s cubic-bezier(0.16,1,0.3,1)';
        setTimeout(() => { b.style.transition = ''; }, 400);
      });
    });
  }

})();

// ── MOBILE DRAWER (global functions for onclick in HTML) ──
function toggleMobileMenu() {
  const d = document.getElementById('mobileDrawer'), o = document.getElementById('mobileOverlay');
  if (!d || !o) return;
  d.classList.toggle('open'); o.classList.toggle('open');
  document.body.style.overflow = d.classList.contains('open') ? 'hidden' : '';
}
function closeMobileMenu() {
  const d = document.getElementById('mobileDrawer'), o = document.getElementById('mobileOverlay');
  if (!d || !o) return;
  d.classList.remove('open'); o.classList.remove('open');
  document.body.style.overflow = '';
}
